import script from "./EditHeaderEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditHeaderEvent.vue?vue&type=script&setup=true&lang=ts"

import "./EditHeaderEvent.vue?vue&type=style&index=0&id=aaa7d286&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaa7d286"]])

export default __exports__